// Casca das telas públicas de conta (login, registro, reset…). Painel de
// marca à esquerda (some no mobile) + área do formulário centralizada.
// A logo (lateral e topbar) leva de volta pra Home; um rodapé com Início +
// suporte fecha a página — as telas de conta não tinham nem home nem rodapé.
import { Link } from 'react-router-dom';
import Brand from './Brand';
import ThemeToggle from './ThemeToggle';
import { abrirWhatsappSuporte, EMAIL_SUPORTE } from '../config';

export default function AuthShell({ children, aside = null, semLateral = false }) {
    const ano = new Date().getFullYear();

    return (
        <div className={`ueb-auth ${semLateral ? 'ueb-auth--solo' : ''}`}>
            {!semLateral && (
                <aside className="ueb-auth-side">
                    <div className="ueb-auth-side-top">
                        <Link to="/" aria-label="Voltar ao início"><Brand onLight /></Link>
                    </div>
                    <div className="ueb-auth-side-body">
                        {aside || (
                            <>
                                <h2>Sua carteira de estudante, digital.</h2>
                                <p>
                                    Emita, acompanhe e valide sua carteira da UEB em um só lugar —
                                    com pagamento seguro e entrega quando você quiser a via física.
                                </p>
                                <ul className="ueb-auth-side-list">
                                    <li>Carteira digital na hora</li>
                                    <li>Pagamento por Pix ou cartão</li>
                                    <li>Via física entregue pelos Correios</li>
                                </ul>
                            </>
                        )}
                    </div>
                    <div className="ueb-auth-side-foot">Universidade do Estudante Brasileiro</div>
                </aside>
            )}

            <main className="ueb-auth-main">
                <div className="ueb-auth-topbar">
                    <Link to="/" className="ueb-auth-topbar-brand" aria-label="Voltar ao início"><Brand compact /></Link>
                    <ThemeToggle />
                </div>
                <div className="ueb-auth-card-wrap">
                    {children}
                </div>

                <footer className="ueb-auth-rodape">
                    <span>© {ano} UEB · Carteirinha de Estudante</span>
                    <div className="ueb-auth-rodape-links">
                        <Link to="/">Início</Link>
                        <button type="button" onClick={abrirWhatsappSuporte}>Suporte</button>
                        <a href={`mailto:${EMAIL_SUPORTE}`}>{EMAIL_SUPORTE}</a>
                    </div>
                </footer>
            </main>
        </div>
    );
}
